export default __webpack_public_path__ + "static/media/Nicole.3db51615.png";